/**
 * 联系人 API（消息域）
 *
 * 任务指派候选人请用 `/tasks/assignee-options`（task.ts getTaskSelectionOptions），
 * 不要再调用已不存在的顶层 `/contacts`。
 */
import { request } from '@/shared/api/request'
import type { UserSummary } from '@/api/common-types'

export type { UserSummary }

/** 消息侧联系人列表（同组聊天） */
export interface MessageContactsResponse {
  contacts: UserSummary[]
  total: number
}

/**
 * @deprecated 任务指派请用 getTaskSelectionOptions（/tasks/assignee-options）。
 * 此处仅兼容旧调用，映射为同组联系人；Metalingual 列表为空。
 */
export interface ContactListResponse {
  same_group_users: UserSummary[]
  metalingual_users: UserSummary[]
  all_users: UserSummary[]
}

/**
 * 获取同组联系人（消息模块）
 */
export const getGroupContacts = (params?: {
  search?: string
}): Promise<MessageContactsResponse> => {
  return request.get('/messages/contacts', { params })
}

/**
 * @deprecated 请用 getGroupContacts 或 getTaskSelectionOptions
 */
export const getContacts = async (): Promise<ContactListResponse> => {
  const response = await getGroupContacts()
  return {
    same_group_users: response.contacts,
    metalingual_users: [],
    all_users: response.contacts,
  }
}

/**
 * @deprecated 服务端无独立 search 端点，走 /messages/contacts?search=
 */
export const searchContacts = async (params: {
  keyword?: string
  group_type?: 'same_group' | 'metalingual' | 'all'
}): Promise<ContactListResponse> => {
  const response = await getGroupContacts({ search: params.keyword })
  return {
    same_group_users: response.contacts,
    metalingual_users: [],
    all_users: response.contacts,
  }
}

export const contactApi = {
  getContacts,
  searchContacts,
  getGroupContacts,
}
